import cloneDeep from 'lodash.clonedeep'
import ordereduuid from '../Helpers/timeuuid'
import { orderItemBase, orderItemModifierBase } from './orderBase'

const translateFromItem = (itemInfo, categoryUUID = null) => {
  let orderItem = cloneDeep(orderItemBase)
  orderItem.orderItemUUID = itemInfo.orderItemUUID
  orderItem.parentOrderItemUUID = itemInfo.parentOrderItemUUID || null
  orderItem.count = itemInfo.count || 0
  orderItem.quantity = itemInfo.quantity != null ? itemInfo.quantity : null
  orderItem.servingID = itemInfo.servingID || null
  orderItem.takeAway = itemInfo.takeAway != null ? itemInfo.takeAway : null
  orderItem.price = itemInfo.price || 0
  orderItem.vat = itemInfo.vat
  orderItem.selectedSizeUUID = itemInfo.selectedSizeUUID || itemInfo.defaultSize
  orderItem.depositType = itemInfo.depositType || null
  orderItem.depositPrice = itemInfo.depositPrice || 0
  orderItem.depositVat = itemInfo.depositVat || 0
  orderItem.package = itemInfo.package || null
  orderItem.itemUUID = itemInfo.uuid
  orderItem.categoryUUID = itemInfo.categoryUUID != null ? itemInfo.categoryUUID :
                             categoryUUID != null ? categoryUUID : 
                                itemInfo.defaultCategoryUUID
  orderItem.notes = itemInfo.notes || ''
  for (let modGroup of itemInfo.modifierGroups) {
    //console.log('MOD GROUP', cloneDeep(modGroup))
    if (modGroup.modifiers == null) continue
    for (let modifier of modGroup.modifiers) {
      let orderModifier = cloneDeep(orderItemModifierBase)
      if((modifier.orderModifierUUID == null && modifier.count != null)) {
        orderModifier.orderModifierUUID = ordereduuid()
      } else {
        if(modifier.orderModifierUUID != null) orderModifier.orderModifierUUID = modifier.orderModifierUUID
      }
      orderModifier.modifierGroupUUID = modGroup.uuid
      orderModifier.modifierUUID = modifier.uuid
      orderModifier.count = modifier.count
      orderModifier.price = modifier.price
      if(orderModifier.orderModifierUUID != null) orderItem.modifiers.push(orderModifier)
    }
  }
  //console.log('translateFromItem ', cloneDeep(itemInfo), cloneDeep(orderItem))
  return orderItem
}

const translateToItem = (itemInfo, orderItem) => {
  //console.log('translateToItem')
  try {
    itemInfo.orderItemUUID = orderItem.orderItemUUID
    itemInfo.parentOrderItemUUID = orderItem.parentOrderItemUUID
    itemInfo.count = orderItem.count
    itemInfo.quantity = orderItem.quantity != null ? orderItem.quantity : null
    itemInfo.servingID = orderItem.servingID || null
    itemInfo.takeAway = orderItem.takeAway != null ? orderItem.takeAway : null
    itemInfo.price = orderItem.price
    itemInfo.vat = orderItem.vat
    itemInfo.selectedSizeUUID = orderItem.selectedSizeUUID || itemInfo.defaultSize
    itemInfo.depositType = orderItem.depositType || null
    itemInfo.depositPrice = orderItem.depositPrice || 0
    itemInfo.depositVat = orderItem.depositVat || 0
    itemInfo.package = orderItem.package || null
    itemInfo.categoryUUID = orderItem.categoryUUID
    itemInfo.notes = orderItem.notes
    itemInfo.storno = orderItem.storno
    if (orderItem.modifiers != null) {
      for (let mod of orderItem?.modifiers || []) {
        if(itemInfo.modifierGroups != null) {
          for(let modifierGroup of itemInfo?.modifierGroups || []) {
            if(modifierGroup.uuid === mod.modifierGroupUUID) {
              for (let itemInfoModifier of modifierGroup?.modifiers || []) {
                if (itemInfoModifier.uuid === mod.modifierUUID) {
                  itemInfoModifier.count = mod.count
                  itemInfoModifier.price = mod.price
                  itemInfoModifier.orderModifierUUID = mod.orderModifierUUID
                }
              }
            }
          }
        }
      }
    }
    return itemInfo
  } catch (e) {
    console.error(e)
    return itemInfo
  }
}

export { translateFromItem, translateToItem }
